import { createSlice } from '@reduxjs/toolkit';

const contractSlice = createSlice({
   name: 'contract',
   initialState: {
      prefilledData: null,
      technologyStacks: null,
      opportunities: null,
      quotation: null,
      allQuotations: null,
      bankDetails: null,
      contractUpdatePrefilledData: null,
      contractCurrency: null,
      selectedContractTypeId: null,
      contractTypePreFillData: null,
   },
   reducers: {
      setContractPrefilledData: (state, action) => {
         state.prefilledData = action.payload;
      },
      setTechnologyStacks: (state, action) => {
         state.technologyStacks = action.payload;
      },
      setOpportunities: (state, action) => {
         state.opportunities = action.payload;
      },
      setQuotation: (state, action) => {
         state.quotation = action.payload;
      },
      setAllQuotations: (state, action) => {
         state.allQuotations = action.payload;
      },
      setBankDetails: (state, action) => {
         state.bankDetails = action.payload;
      },
      setContractUpdatePrefilledData: (state, action) => {
         state.contractUpdatePrefilledData = action.payload;
      },
      setContractCurrency: (state, action) => {
         state.contractCurrency = action.payload;
      },
      setSelectedContractTypeId: (state, action) => {
         state.selectedContractTypeId = action.payload;
      },
      setContractTypePreFillData: (state, action) => {
         state.contractTypePreFillData = action.payload;
      },
      clearContractTypePreFill: (state) => {
         state.selectedContractTypeId = null;
         state.contractTypePreFillData = null;
      },
   },
});

export const {
   setAllQuotations,
   setContractPrefilledData,
   setTechnologyStacks,
   setOpportunities,
   setQuotation,
   setBankDetails,
   setContractUpdatePrefilledData,
   setContractCurrency,
   setSelectedContractTypeId,
   setContractTypePreFillData,
   clearContractTypePreFill,
} = contractSlice.actions;

export default contractSlice.reducer;
